import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
//Import UI Components
import { Button, Modal } from '@geneui/components';
//Import Components
import CampaignInfoContent from './CampaignInfoContent';
// Import Constants
import { ModalsActions, l } from 'constants/common';
//Import Version History
import {
    VersionHistoryIconWithPopover,
    VersionHistorySelectedVersionLabel,
    VersionHistoryProviderHOC,
} from 'components/VersionHistory';
// Import Enums
import { ObjectTypeEnum } from 'enums';

const CampaignInfoModal = (props) => {
    const { handleClose, isVisible, campaignId, handleInfoModalActionClick, templateProviders, isInReportPage } = props;
    const { t } = useTranslation();

    return (
        <>
            <Modal
                closeOnClickOutside={true}
                onCancel={() => handleClose(ModalsActions.CLOSE)}
                background="dark-background"
                position="center"
                visible={isVisible}
                closable={false}
                size="content-size"
                className="crm-object-list-modal crm-template-info-modal campaign-info-modal"
                title={
                    <div className="crm-object-list-modal-head">
                        <span className="crm-object-list-modal-h-text">{t(l.CampaignInfo)}</span>
                        <div className="crm-object-list-modal-h-icons">
                            <VersionHistorySelectedVersionLabel
                                objectId={campaignId}
                                objectTypeId={ObjectTypeEnum.Campaign}
                            />
                            <VersionHistoryIconWithPopover
                                objectId={campaignId}
                                objectTypeId={ObjectTypeEnum.Campaign}
                            />
                        </div>
                    </div>
                }
                footer={
                    <Button appearance="minimal" onClick={() => handleClose(ModalsActions.CLOSE)}>
                        {t(l.Close)}
                    </Button>
                }
            >
                <CampaignInfoContent
                    campaignId={campaignId}
                    handleInfoModalActionClick={handleInfoModalActionClick}
                    templateProviders={templateProviders}
                    isInReportPage={isInReportPage}
                />
            </Modal>
        </>
    );
};

CampaignInfoModal.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    campaignId: PropTypes.string.isRequired,
    handleInfoModalActionClick: PropTypes.func,
    templateProviders: PropTypes.object,
    isInReportPage: PropTypes.bool,
};

export default VersionHistoryProviderHOC(CampaignInfoModal);
